import type { Legal, NavLinkColumn } from './types'

export const legal_sg: Legal[] = [
  {
    key: 'privacy_notice',
    name: 'Privacy Notice',
    href: '/privacy/entity_singapore',
  },
  {
    key: 'status',
    name: 'Status',
    href: 'https://status.crypto.com',
  },
]

export const desktop_sg: NavLinkColumn[] = [
  [
    {
      tTitle: 'products.app',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.buyAndSell',
          href: '/sg/app',
        },
        {
          tTitle: 'products.earn',
          href: '/sg/earn',
        },
        {
          tTitle: 'products.pay',
          href: '/sg/pay',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.cards',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.metalCards',
          href: '/sg/cards',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.resources',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'company.research',
          href: 'https://crypto.com/sg/research',
        },
        {
          tTitle: 'products.por',
          href: '/sg/proof-of-reserves',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'navbar.company',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'company.about',
          href: '/sg/about',
        },
        {
          tTitle: 'company.careers',
          href: '/sg/careers',
        },
        {
          tTitle: 'company.security',
          href: '/sg/security',
        },
        {
          tTitle: 'company.contact',
          href: '/sg/about#page-contact',
        },
        {
          tTitle: 'company.capital',
          href: '/sg/capital',
        },
        {
          tTitle: 'company.climate',
          href: 'https://crypto.com/company-news/crypto-coms-climate-commitment-2',
        },
        {
          tTitle: 'company.affiliate',
          href: '/affiliate',
        },
        {
          tTitle: 'company.partners',
          href: '/partners',
        },
      ],
    },
  ],
]

export const mobile_sg = desktop_sg.flatMap((menu) => menu)
